module.exports = __webpack_public_path__ + "img/aura.953998b9.png";